<template>
  <div
    :class="{
      banner: true,
      rounded: rounded,
      outlined: outlined,
      [color]: color,
      'loading-skeleton': loading
    }"
    :style="{ padding: padding }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    rounded: { type: Boolean, required: false, default: true },
    outlined: { type: Boolean, required: false, default: false },
    color: { type: String, required: false, default: '' },
    padding: { type: String, required: false, default: '' },
    loading: { type: Boolean, required: false, default: false }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.banner {
  height: fit-content;
  width: 100%;
  background-color: $neutral200;
  padding: 24px;

  &.rounded {
    border-radius: 8px;
  }

  &.outlined {
    border-width: 1px;
    border-style: solid;
    border-color: $positive300;
  }

  &.success {
    background-color: $positive100;
    border-color: $positive300;
  }

  &.violet {
    background-color: $purple200;
    border-color: $purple400;
  }

  &.white {
    background-color: $neutral100 !important;
    border-color: $neutral300 !important;
  }

  &.white-dark-blue {
    background-color: $neutral100;
    border-color: $darkBlue200;
  }
}
</style>
